<template>
  <div>
    <span>{{ value }}</span>
  </div>
</template>

<script>
import BaseControlMixin from '@/components/controls/mixins/BaseControl';
import I18N from '@/mixins/I18N';


export default {
  name: 'EnumDisplayField',
  mixins: [
    BaseControlMixin,
    I18N,
  ],
  computed: {
    value() {
      if (this.validation === null || typeof this.validation !== 'object') {
        return this.getSingleVar.value;
      }
      try {
        return this.validation[this.selectedLanguage][this.getSingleVar.value];
      } catch (err) {
        this.$log.error(err, 'lang:', this.selectedLanguage, 'val:', this.getSingleVar.value);
        return this.getSingleVar.value;
      }
    },
  },
};
</script>

<style scoped>

</style>
